export const SERVICE_RAIN_COLLAR_RESEAL = {
  label: 'Reseal Rain Collar',
  value: 'SERVICE_RAIN_COLLAR_RESEAL'
};
